import { useState, useEffect, useRef } from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import ErrorIcon from '@material-ui/icons/Error';
import { useStyles } from './style';

type ValidationWarningProps = {
  text?: string;
  timeout?: number;
  handleInitErrors: () => void;
  Component: React.ReactElement;
} & Pick<TooltipProps, 'placement'>;

const ValidationWarning = ({
  placement = 'bottom-start',
  text,
  timeout = 3000,
  Component,
  handleInitErrors,
}: ValidationWarningProps) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const parentRef = useRef<HTMLDivElement>(null);

  const showWarning = () => setOpen(true);
  const hideWarning = () => setOpen(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (text && !open) {
      showWarning();

      if (parentRef.current) {
        parentRef.current.scrollIntoView({
          block: 'center',
        });
      }

      timeoutId = setTimeout(() => {
        hideWarning();
      }, timeout);
    } else {
      hideWarning();
    }

    return () => {
      clearTimeout(timeoutId);
    };

    /* eslint-disable-next-line */
  }, [text]);

  const getTitle = () => {
    return (
      <div className={classes.flex}>
        <ErrorIcon className={classes.icon} />
        <span className={classes.title}>{text}</span>
      </div>
    );
  };

  return (
    <Tooltip
      open={open}
      title={getTitle()}
      arrow
      placement={placement}
      classes={{
        tooltip: classes.tooltip,
      }}
      TransitionProps={{
        onExited: () => handleInitErrors(),
      }}
    >
      <div ref={parentRef}>{Component}</div>
    </Tooltip>
  );
};

export default ValidationWarning;
